import {getTheme} from 'mattermost-redux/selectors/entities/preferences';
import {type ThemeType} from 'packages/types/src/themes';
import {useAppSelector} from 'stores/redux_store';

type ThemeGlobalType = 'light' | 'dark';

const themeTypeToGlobal: Record<ThemeType | 'custom', ThemeGlobalType> = {
    stimedark: 'dark',
    stime: 'light',
    Denim: 'light',
    Sapphire: 'light',
    Quartz: 'light',
    Indigo: 'dark',
    Onyx: 'dark',
    custom: 'light',
};

export const useThemeTypeToGlobal = (): ThemeGlobalType => {
    const theme = useAppSelector(getTheme);

    if (theme.type) {
        return themeTypeToGlobal[theme.type];
    }

    return themeTypeToGlobal.custom;
};
